/* globals EasyPost */
import Backbone from 'backbone';

import { setLocation, location } from 'utils/wrappers';
import { setStoredValue } from 'utils/storage';

const base = Backbone.Router.extend({
  routes: {},
  targetEl: '#content-area',
  loggedIn: true,

  renderView(instance) {
    instance.render();
    const oldView = EasyPost.Globals.currentView;
    if (oldView) {
      oldView.removeSubviews();
      oldView.remove();
      oldView.unbind();
      oldView.undelegateEvents();
    }
    EasyPost.Globals.currentView = instance;
    $('body').find(this.targetEl).html(instance.el);

    // content has been added to page. Run onDomRefresh script
    instance.onDomRefreshBase();
  },

  redirectToHome() {
    setLocation('/');
  },

  redirectToLogin() {
    setLocation('/signin');
  },

  redirectToLoggedIn() {
    setLocation('/account/shipments');
  },

  redirectUnlessLoggedIn(callback) {
    if (EasyPost.Globals.currentUser && EasyPost.Globals.currentUser.isLoggedIn()) {
      return callback();
    }

    const currentLocation = (location().pathname || '') + (location().hash || '');

    setStoredValue('signinLocation', currentLocation);
    return this.redirectToLogin();
  },

  redirectUnlessLoggedOut() {
    if (EasyPost.Globals.currentUser && EasyPost.Globals.currentUser.isLoggedIn()) {
      this.redirectToLoggedIn();
      return false;
    }

    return true;
  },

  enforceLogin(callback) {
    if (EasyPost.Globals.firstFetchComplete) {
      this.redirectUnlessLoggedIn(callback);
    } else {
      EasyPost.Globals.currentUser.once('error sync', () => {
        this.redirectUnlessLoggedIn(callback);
      }, this);
    }
  },

  enforceNotLoggedIn() {
    // TODO: rewrite this to use a callback like enforceLogin does
    if (EasyPost.Globals.firstFetchComplete) {
      return this.redirectUnlessLoggedOut();
    }

    EasyPost.Globals.currentUser.once('error sync', this.redirectUnlessLoggedOut, this);
    return true;
  },
  checkForHash(substring = 1) {
    return Backbone.history.location.hash.length > 0
        && Backbone.history.location.hash.substring(substring);
  },
});

export default base;



// WEBPACK FOOTER //
// ./app/routers/base.js